export const UPDATE_CLIMBER_FACETS_SCORES = `
  mutation updateClimberFacets($input: ClimberFacetsInput!) {
    updateClimberFacets(input: $input) {
      facet
    }
  }
`;

export const GET_MY_FEATURES = `
  query getMyFeatures {
    getMyFeatures {
      path
      features
    }
  }
`;

export const GET_CONTENT_SUBSCRIPTIONS_FOR_ENTITY = `
  query getContentSubscriptionsForEntity($parentID: String!) {
    getContentSubscriptionsForEntity(parentID: $parentID) {
      id
      path
      parentID
      shardID
      contractTTL
      featureIDs
    }
  }
`;

export const CREATE_CLIMBER_SUBSCRIPTION = `
  mutation createClimberSubscription($input: CreateClimberSubscriptionInput!) {
    createClimberSubscription(input: $input) {
      id
      parentID
      featureIDs
    }
  }
`;

export const CREATE_OR_UPDATE_CONTENT_SUBSCRIPTION = `
  mutation createOrUpdateContentSubscription($input: ContentSubscriptionInput!) {
    createOrUpdateContentSubscription(input: $input) {
      id
      path
      parentID
      featureIDs
    }
  }
`;

export const GET_LOGO = `
query getLogo($districtID: String!) {
  getLogo(districtID: $districtID) {
    logo
    error
  }
}`;

export const UPDATE_LADDER_PROGRESS = `
  mutation updateLadderProgress($input: LadderProgressInput!) {
    updateClimberLadderProgress(input: $input) {
      highScore
      maxScore
      ladderId
      learnosityReference
      learnositySessionId
      externalRegistrationId
      numberOfSessions
      overallStatus
      completeDate
    }
  }
`;

export const GET_MY_PROGRESS = `
  query getMyProgress($productCode: String!) {
    getMyProgress(productCode: $productCode) {
      id
      parentID
      productCode
      updatedAt
      ladderProgress {
        completeDate
        highScore
        maxScore
        ladderId
        learnosityReference
        learnositySessionId
        externalRegistrationId
        numberOfSessions
        overallStatus
      }
      facets {
        ladderId
        facets {
          facet
          score
        }
      }
      profileChoices {
        avatar
        goal
        catchphrase
        birthMonth
        birthYear
        careerStage
        careerConfidence
        topThemes
      }
      careerPlan {
        careerPlanId
        planStatus
        pathwayId
        lastUpdatedAt
        approvedAt
      }
      coursePlan {
        coursePlanId
        planStatus
        pathwayId
        lastUpdatedAt
        approvedAt
        programId
        programName
        districtPathwayId
        districtPathwayName
        createdAt
      }
      careerClimbs {
        id
        learnosityTag
        startDate
        completeDate
        updatedAt
      }
      courseProgress {
        id
        courseID
        completedAt
        updatedAt
      }
    }
  }
`;

export const GET_CLIMBERS_PROGRESS = `
  query getClimbersProgress($climberIds: [ID!]!) {
    getClimbersProgress(climberIds: $climberIds) {
      id
      parentID
      productCode
      updatedAt
      ladderProgress {
        completeDate
        highScore
        maxScore
        ladderId
        learnosityReference
        learnositySessionId
        externalRegistrationId
        numberOfSessions
        overallStatus
      }
      facets {
        ladderId
        facets {
          facet
          score
        }
      }
      profileChoices {
        avatar
        goal
        catchphrase
        birthMonth
        birthYear
        careerStage
        careerConfidence
        topThemes
      }
      careerPlan {
        careerPlanId
        planStatus
        pathwayId
        lastUpdatedAt
        approvedAt
      }
      climbPlan {
        climbPlanId
        planStatus
        hatId
        lastUpdatedAt
        approvedAt
        createdAt
        programName
        lastSubmittedAt
      }
      coursePlan {
        coursePlanId
        planStatus
        pathwayId
        lastUpdatedAt
        approvedAt
        programId
        programName
        districtPathwayId
        districtPathwayName
        cteCourseSequence {
          id
          name
        }
        createdAt
      }
      shoutOutCount
      careerClimbs {
        id
        learnosityTag
        startDate
        completeDate
        updatedAt
      }
      courseProgress {
        id
        courseID
        completedAt
        updatedAt
      }
      pathways {
        pathwayId
        sentiment
        sentimentUpdatedAt
      }
      clusters {
        id
        clusterId
        status
        updatedAt
      }
      hatProgress {
        topHats {
          hatId
          addedAt
        }
        bottomHats {
          hatId
          addedAt
        }
        hatSentiments {
          hatId
          sentiment
          updatedAt
        }
        hatsSaved {
          hatId
          addedAt
        }
      }
    }
  }
`;

export const SET_CAREER_CLIMB_PROGRESS = `
  mutation setCareerClimbProgress($input: SetCareerClimbProgressInput!) {
    setCareerClimbProgress(input: $input) {
      id
      parentID
      careerClimbs {
        id
        learnosityTag
        startDate
        completeDate
        updatedAt
      }
    }
  }
`;

export const SET_COURSE_COMPLETION = `
  mutation setCourseCompletion($input: SetCourseCompletionInput!) {
    setCourseCompletion(input: $input) {
      id
      parentID
      courseProgress {
        id
        courseID
        completedAt
        updatedAt
      }
    }
  }
`;

export const GET_EARNED_BADGES = `
  query getEarnedBadges($recentEvents: [RecentEventInput!], $productPlans: [String!], $checkForNew: Boolean!, $product: String) {
    getEarnedBadges(recentEvents: $recentEvents, productPlans: $productPlans, checkForNew: $checkForNew, product: $product) {
      earnedBadges {
        id
        earned
        progress
        earnedAt
        acknowledged
        acknowledgedAt
        earningEvents {
          id
          eventType
          timestamp
          data
        }
      }
    }
  }
`;

export const ACKNOWLEDGE_BADGE = `
  mutation acknowledgeBadge($badgeId: ID!) {
    acknowledgeBadge(badgeId: $badgeId) {
      id
      earned
      progress
      earnedAt
      acknowledged
      acknowledgedAt
    }
  }
`;

// input CompleteAwardInput {
//   awardId: String!
//   awardType: String!
//   shardID: String!
//   userPath: String!
// }
export const COMPLETE_AWARD = `
  mutation completeAward($input: CompleteAwardInput!) {
    completeAward(input: $input) {
      id
      awardID
      climberID
      parentID
      completedAt
      path
      shardID
      url
  }
}`;

export const GET_MY_AWARDS = `
query getMyAwards {
  getAwards {
    completedAt
    id
    path
    shardID
    awardID
    url
  }
}`;

export const GET_MY_PRODUCTS = `
query getMyProducts {
  getMyProducts {
    code
    name
    title
    description
    path
    color
    icon { url }
    learnerPlanCodes
    educatorPlanCodes
    startDate
    endDate
    gracePeriodDays
    sections { id name }
  }
}`;

export const GET_MY_ENROLLMENTS = `
query getMyEnrollments {
  getMyEnrollments {
    id
    scope
    entityId
    entityName
    grades
  }
}`;

export const GET_ENROLLMENTS_FOR_USER = `
query getEnrollmentsForUser($userId: ID!) {
  getEnrollmentsForUser(userId: $userId) {
    id
    scope
    entityId
    entityName
    grades
  }
}`;

// Legacy query - deprecated, use GET_MY_AWARDS instead
// export const GET_AWARDS_BY_PATH = `
// query getAwardsByPath($path: String, $shardID: String!) {
//   getAwards(
//     path: $path
//     shardID: $shardID
//   ) {
//     completedAt
//     id
//     path
//     shardID
//     awardID
//   }
// }`;

export const GET_AWARDS_BY_PARENT_ID = `
query getAwardsByParentID($parentID: String!) {
  getAwardsByParentID(parentID: $parentID) {
    completedAt
    id
    path
    shardID
    awardID
    parentID
    climberID
  }
}`;

export const GET_AWARDS_BY_SECTION_ID = `
query getAwardsBySectionId($sectionId: String!, $nextToken: String, $limit: Int) {
  getAwardsBySectionId(sectionId: $sectionId, nextToken: $nextToken, limit: $limit) {
    awards {
      climberID
      awardID
      completedAt
    }
    nextToken
  }
}`;

export const GET_HAT_STATUSES_BY_CLIMBER_ID = `
query getHatStatusesByClimberID($climberId: String!) {
  getHatStatusesByClimberID(climberId: $climberId) {
    hatId
    statuses
  }
}`;

export const COMPLETE_BUILDING_BLOCK_ACTIVITY = `
  mutation createOrUpdateBuildingBlockActivity($input: BuildingBlockActivityInput!) {
    createOrUpdateBuildingBlockActivity(input: $input) {
      id
      parentID
      shardID
      categoryID
      activityID
      userActivityDescription
      userActivityDuration
      sentiments {
        connectorId
        sentiment
        reason
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_BUILDING_BLOCK_ACTIVITY = `
  mutation deleteBuildingBlockActivity($input: DeleteBuildingBlockActivityInput!) {
    deleteBuildingBlockActivity(input: $input) {
      success
      message
    }
  }
`;

export const GET_HAT_STATUSES = `
  query GetHatStatuses($product: String) {
    getHatSaved(product: $product)
    getHatFavorites(product: $product)
    getHatHeardOfs(product: $product) {
      hatId
      heardOf
    }
    getHatSentiments(product: $product) {
      hatId
      sentiment
      updatedAt
    }
    getHatReveals(product: $product) {
      hatId
      type
      revealedAt
    }
    getTopHats(product: $product) {
      hatId
      addedAt
    }
    getBottomHats(product: $product) {
      hatId
      addedAt
    }
  }
`;

export const SET_HAT_REVEALED = `
  mutation setHatRevealed($hatId: ID!, $type: HatRevealType!, $product: String) {
    setHatRevealed(hatId: $hatId, type: $type, product: $product) {
      hatId
      type
      revealedAt
    }
  }
`;

export const SET_TOP_HAT = `
  mutation setTopHat($slotIndex: Int!, $hatId: ID!, $product: String) {
    setTopHat(slotIndex: $slotIndex, hatId: $hatId, product: $product) {
      hatId
      addedAt
    }
  }
`;

export const REMOVE_TOP_HAT = `
  mutation removeTopHat($hatId: ID!, $product: String) {
    removeTopHat(hatId: $hatId, product: $product) {
      hatId
      addedAt
    }
  }
`;

export const SET_BOTTOM_HAT = `
  mutation setBottomHat($slotIndex: Int!, $hatId: ID!, $product: String) {
    setBottomHat(slotIndex: $slotIndex, hatId: $hatId, product: $product) {
      hatId
      addedAt
    }
  }
`;

export const REMOVE_BOTTOM_HAT = `
  mutation removeBottomHat($hatId: ID!, $product: String) {
    removeBottomHat(hatId: $hatId, product: $product) {
      hatId
      addedAt
    }
  }
`;

export const GET_HAT_PACKS = `
  query getHatPacks($product: String) {
    getHatPacks(product: $product) {
      hatPackId
      earnedAt
      source
      acknowledged
      acknowledgedAt
    }
  }
`;

export const AWARD_HAT_PACK = `
  mutation awardHatPack($hatPackId: ID!, $source: String!, $acknowledged: Boolean, $product: String) {
    awardHatPack(hatPackId: $hatPackId, source: $source, acknowledged: $acknowledged, product: $product) {
      hatPackId
      earnedAt
      source
      acknowledged
      acknowledgedAt
    }
  }
`;

export const ACKNOWLEDGE_HAT_PACK = `
  mutation acknowledgeHatPack($hatPackId: ID!, $product: String) {
    acknowledgeHatPack(hatPackId: $hatPackId, product: $product) {
      hatPackId
      earnedAt
      source
      acknowledged
      acknowledgedAt
    }
  }
`;

export const GET_HAT_ASSESSMENT_STATUSES = `
  query getHatAssessmentStatuses($hatId: ID!, $product: String) {
    getHatAssessmentStatuses(hatId: $hatId, product: $product) {
      completedAt
      hatId
      assessmentType
      learnositySessionId
      score
      maxScore
      status
    }
  }
`;

export const GET_HAT_ASSESSMENT_STATUS = `
  query getHatAssessmentStatus($assessmentType: String!, $hatId: ID!, $product: String) {
    getHatAssessmentStatus(assessmentType: $assessmentType, hatId: $hatId, product: $product) {
      hatId
      assessmentType
      completedAt
      learnositySessionId
      score
      maxScore
      status
    }
  }
`;

export const SET_HAT_ASSESSMENT_STATUS = `
  mutation setHatAssessmentStatus(
    $assessmentType: String!
    $hatId: ID!
    $status: String!
    $score: Float!
    $maxScore: Float!
    $product: String
  ) {
    setHatAssessmentStatus(
      assessmentType: $assessmentType
      hatId: $hatId
      status: $status
      score: $score
      maxScore: $maxScore
      product: $product
    ) {
      hatId
      assessmentType
      status
      score
      maxScore
      createdAt
      completedAt
      learnositySessionId
    }
  }
`;

export const GET_HAT_SENTIMENTS = `
  query getHatSentiments($product: String) {
    getHatSentiments(product: $product) {
      hatId
      sentiment
    }
  }
`;

export const SET_HAT_SENTIMENT_STATUS = `
  mutation setHatSentimentStatus($hatId: ID!, $sentiment: HatSentiment, $product: String) {
    setHatSentimentStatus(hatId: $hatId, sentiment: $sentiment, product: $product)
  }
`;

export const GET_HAT_STATISTICS = `
  query getHatStatistics($product: String) {
    getHatStatistics(product: $product) {
      hatsFavorited
      hatsSaved
      hatsLiked
      hatsDisliked
      hatsNotForMe
      hatsLoved
      hatsHeardOf
      hatsNotHeardOf
    }
  }
`;

export const GET_GENERIC_USER_DATA = `
  query getGenericUserByEmail($email: String!) {
    getUserByEmail(email: $email) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
    }
  }
`;

export const GET_CLIMBER_DATA = `
  query getClimberBySub($sub: String!) {
    getClimberBySub(sub: $sub) {
      id
      lastName
      firstName
      username
      xp
      shardID
      sub
      parentID
      path
      receivedSurvey
      contractTTL
      profileChoices {
        avatar
        birthMonth
        birthYear
        catchphrase
        goal
        careerStage
        careerConfidence
        topThemes
      }
    }
  }
`;

export const GET_MY_USER_RECORDS = `
    query GetMyUserRecords {
      getMyUserRecords {
        applicationOnlineID
        canAddPeers
        contractTTL
        preferredID
        dob
        email
        careerPlan {
          lastUpdatedAt
          planStatus
          pathwayId
          careerPlanId
          approvedAt
        }
        coursePlan {
          lastUpdatedAt
          planStatus
          pathwayId
          coursePlanId
          programId
          programName
          districtPathwayId
          districtPathwayName
          cteCourseSequence {
            id
            name
          }
          approvedAt
          createdAt
        }
        firstName
        id
        lastName
        lastRepairedDate
        middleName
        parentID
        path
        xp
        username
        sub
        shardID
        receivedSurvey
        activeDistrictId
        helpDesk
        grades
      }
    }
  `;

export const GET_CLIMBER_BY_ID = `
  query getClimberById($id: ID!) {
    getClimberById(id: $id) {
      id
      lastName
      firstName
      username
      xp
      shardID
      email
      sub
      parentID
      path
      preferredID
      receivedSurvey
      profileChoices {
        avatar
        birthMonth
        birthYear
        catchphrase
        goal
        careerStage
        careerConfidence
        topThemes
      }
      careerPlan {
        lastUpdatedAt
        planStatus
        pathwayId
        careerPlanId
        approvedAt
      }
      coursePlan {
        lastUpdatedAt
        planStatus
        pathwayId
        coursePlanId
        programId
        programName
        districtPathwayId
        districtPathwayName
        cteCourseSequence {
          id
          name
        }
        approvedAt
        createdAt
      }

    }
  }
`;

export const GET_CLIMBER_BY_YEPSID_DOB = `
  query getClimberByDobYeps($dob: String!, $yepsID: String!) {
    getClimberByDobYeps(dob: $dob, yepsID: $yepsID ) {
      id
      lastName
      firstName
      username
      sub
      path
    }
  }
`;

export const GET_SCHOOL_STAFF_DATA = `
  query getSchoolStaffBySub($sub: String!) {
    getSchoolStaffBySub(sub: $sub) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
      canAddPeers
    }
  }
`;

export const GET_SCHOOL_STAFF_DATA_BY_ID = `
  query getSchoolStaffById($id: ID!) {
    getSchoolStaffById(id: $id) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
      canAddPeers
    }
  }
`;

// Safe to extend: no other caller selects from this query. Email and
// districtName are added for the staff Person Detail page.
// HATS STAFF ONLY. Edits any stored profile field on a person, chosen by id
// prefix. Update-only, and `sub`/`username` cannot be sent — see the resolver.
export const UPDATE_PERSON_AS_STAFF = `
  mutation updatePersonAsStaff($input: StaffPersonInput!) {
    updatePersonAsStaff(input: $input) {
      id
      path
      firstName
      lastName
      middleName
      email
      preferredID
      canAddPeers
    }
  }
`;

// A district admin editing school staff in their own district: names and
// email only.
export const UPDATE_SCHOOL_STAFF_PROFILE = `
  mutation updateSchoolStaffProfile($input: SchoolStaffProfileInput!) {
    updateSchoolStaffProfile(input: $input) {
      id
      path
      firstName
      lastName
      middleName
      email
    }
  }
`;

export const GET_DISTRICT_ADMIN_DATA_BY_ID = `
  query getDistrictAdminById($id: ID!) {
    getDistrictAdminById(id: $id) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
      canAddPeers
      email
      districtName
    }
  }
`;

export const GET_SCHOOL_DATA = `
  query getSchoolById($id: ID!) {
    getSchoolById(id: $id) {
      id
      parentID
      path
      shardID
      schoolName
      contractTTL
    }
  }
`;

export const GET_DISTRICT_DATA = `
  query getDistrictById($id: ID!) {
    getDistrictById(id: $id) {
      contractTTL
      districtName
      loginMethod
      id
      parentID
      path
      shardID
      syncID
      centralizedAssignments
      country
      state
      msa
      nomenclature
      worksiteRequirements
      accessToken
      shouldSync
      checkinStartMonth
      checkinStartDay
      checkinEndMonth
      checkinEndDay
      planAvailability {
        startMonth
        startDay
        endMonth
        endDay
      }
      isSYEP
      resourceHubUrl
    }
  }
`;

export const GET_SUPERVISORY_UNION_DATA = `
  query getSupervisoryUnionById($id: ID!) {
    getSupervisoryUnionById(id: $id) {
      unionName
      id
      parentID
      path
    }
  }
`;

export const GET_TEACHER_DATA = `
  query getTeacherBySub($sub: ID!) {
    getTeacherBySub(sub: $sub) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
    }
  }
`;

export const GET_TEACHER_DATA_BY_ID = `
  query getTeacherById($id: ID!) {
    getTeacherById(id: $id) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
    }
  }
`;

export const GET_SUPERADMIN_DATA_BY_ID = `
  query getSuperAdminById($id: ID!) {
    getSuperAdminById(id: $id) {
      id
      lastName
      firstName
      username
      sub
      parentID
      path
      activeDistrictId
    }
  }
`;

export const SET_ACTIVE_DISTRICT = `
  mutation setActiveDistrict($districtId: String) {
    setActiveDistrict(districtId: $districtId) {
      id
      activeDistrictId
      shardID
    }
  }
`;

export const GET_SECTION_DATA = `
  query getSectionData($id: ID!) {
    getSectionById(id: $id) {
      id
      parentID
      path
      shardID
      careerClimbs
      sectionName
      schoolName
      coachSubscription
      climberSubscription
      contractTTL
      program
      serviceOption
      sessionIDs
    }
  }
`;

// HATS STAFF ONLY, refused in an SSO district. Omitted fields are left alone —
// notably climberSubscription / coachSubscription, which this form never shows
// and must not clear.
export const CREATE_OR_UPDATE_SECTION = `
  mutation createOrUpdateSection($input: SectionInput) {
    createOrUpdateSection(input: $input) {
      id
      path
      parentID
      sectionName
      sessionIDs
    }
  }
`;

// Refuses a class that still has enrolments. `dryRun` reports the count.
export const DELETE_SECTION = `
  mutation deleteSection($input: DeleteSectionInput!) {
    deleteSection(input: $input) {
      deleted
      blocked
      sectionName
      enrollments
    }
  }
`;

export const GET_SECTIONS_FOR_SCHOOL = `
  query getSectionsForSchool($parentID: String) {
    getSectionsForSchool(parentID: $parentID) {
      id
      parentID
      path
      shardID
      sectionName
      sessionIDs
    }
  }
`;

export const GET_TEACHERS_FOR_SECTION = `
  query getTeachersForSection($parentID: String) {
    getTeachersForSection(parentID: $parentID) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
      contractTTL
      email
      enrollmentId
      enrollmentPath
    }
  }
`;

export const GET_SCHOOLSTAFF_FOR_SCHOOL = `
  query getSchoolStaffForSchool($parentID: String) {
    getSchoolStaffForSchool(parentID: $parentID) {
      canAddPeers
      contractTTL
      email
      firstName
      id
      lastName
      middleName
      parentID
      path
      shardID
      sub
      username
      enrollmentId
      enrollmentPath
    }
  }
`;

export const GET_ADMIN_FOR_DISTRICT = `
  query getAdminsForDistrict($parentID: String) {
    getAdminsForDistrict(parentID: $parentID) {
      canAddPeers
      contractTTL
      email
      firstName
      id
      lastName
      parentID
      path
      shardID
      sub
      username
    }
  }
`;

// HATS STAFF ONLY, and refused in an SSO district. Omitted fields are left
// alone on an existing school.
export const CREATE_OR_UPDATE_SCHOOL = `
  mutation createOrUpdateSchool($input: SchoolInput) {
    createOrUpdateSchool(input: $input) {
      id
      path
      parentID
      schoolName
      address
      shardID
    }
  }
`;

// Refuses a school that still has sections or staff. `dryRun` reports the
// counts without deleting.
export const DELETE_SCHOOL = `
  mutation deleteSchool($input: DeleteSchoolInput!) {
    deleteSchool(input: $input) {
      deleted
      blocked
      schoolName
      sections
      staff
    }
  }
`;

// Hats-staff variant of GET_SCHOOLS_FOR_DISTRICT, with `address`.
//
// A SEPARATE QUERY ON PURPOSE. Adding a field to the shared one breaks it for
// every caller until the schema ships — and that query backs the district
// admin's own Schools page, so a staff feature would have taken /sites down
// for customers in the window between merge and deploy.
export const GET_SCHOOLS_FOR_DISTRICT_STAFF = `
  query getSchoolsForDistrictStaff($parentID: String) {
    getSchoolsForDistrict(parentID: $parentID) {
      contractTTL
      id
      parentID
      path
      schoolName
      shardID
      address
    }
  }
`;

export const GET_SCHOOLS_FOR_DISTRICT = `
  query getSchoolsForDistrct($parentID: String) {
    getSchoolsForDistrict(parentID: $parentID) {
      contractTTL
      id
      parentID
      path
      schoolName
      shardID
    }
  }
`;

// Any user type by email — climber, coach, staff, admin. The email-index is
// exact-match, so this is a lookup rather than a search.
export const GET_GENERIC_USER_BY_ID = `
  query getGenericUserById($id: ID!) {
    getGenericUserById(id: $id) {
      id
      firstName
      lastName
      email
      username
      sub
      parentID
      path
      shardID
    }
  }
`;

export const GET_GENERIC_USER_BY_EMAIL = `
  query getGenericUserByEmail($email: String!) {
    getGenericUserByEmail(email: $email) {
      id
      firstName
      lastName
      email
      username
      sub
      parentID
      path
      shardID
    }
  }
`;

// Create or edit a district. HATS STAFF ONLY — the resolver rejects any caller
// whose id is not `hnl-`. Omitted fields are left alone on an existing
// district, so a partial edit cannot erase configuration it does not carry.
export const CREATE_OR_UPDATE_DISTRICT = `
  mutation createOrUpdateDistrict($input: DistrictInput) {
    createOrUpdateDistrict(input: $input) {
      id
      path
      parentID
      shardID
      districtName
      loginMethod
      country
      state
      msa
      nomenclature
      contractTTL
      productCodes
      educatorProductCodes
    }
  }
`;

// Delete a district. HATS STAFF ONLY. `dryRun: true` reports what would block
// the delete — the dialog uses it before offering the button, and the delete
// re-runs the same check, so a district that gains a school in between is
// still refused.
export const DELETE_DISTRICT = `
  mutation deleteDistrict($input: DeleteDistrictInput!) {
    deleteDistrict(input: $input) {
      deleted
      blocked
      districtName
      schools
      sections
      users
    }
  }
`;

// Hats staff only. Every district in every organization —
// getDistrictsForUnion answers for one org, which is not what staff administer.
export const GET_ALL_DISTRICTS = `
  query getAllDistricts {
    getAllDistricts {
      id
      parentID
      path
      districtName
      shardID
      state
      country
      loginMethod
      isSYEP
      nomenclature
      contractTTL
      msa
      productCodes
      educatorProductCodes
    }
  }
`;

export const GET_DISTRICTS_FOR_UNION = `
  query getDistrictsForUnion($parentID: String) {
    getDistrictsForUnion(parentID: $parentID) {
      id
      parentID
      path
      districtName
      shardID
      state
      country
      loginMethod
      isSYEP
      # Needed by the Hats staff edit form, which pre-populates from this list
      # rather than refetching one district.
      nomenclature
      contractTTL
    }
  }
`;

// Lean educator roster for a school: only the fields a roster table renders, plus
// the section names it groups by. One request in place of the per-section
// getSectionClimbersData + getSectionData fan-out.
//
// No section argument — the server scopes the roster from the caller's role
// (admins/staff get the whole school, a coach gets only the sections they teach).
// No progress data either; overlay counts with GET_CLIMBERS_PROGRESS for the rows
// currently on screen.
export const GET_SCHOOL_ROSTER = `
  query getSchoolRoster($input: MSSchoolRosterInput!) {
    getSchoolRoster(input: $input) {
      climbers {
        id
        firstName
        lastName
        preferredID
        grades
        sectionIDs
      }
      sections {
        id
        sectionName
      }
    }
  }
`;

export const GET_SECTION_CLIMBERS_DATA = `
  query getSectionClimbersData($sectionID: String!, $nextToken: String, $limit: Int) {
    getClimbersBySectionId(sectionID: $sectionID, nextToken: $nextToken, limit: $limit) {
      climbers {
        id
        firstName
        lastName
        parentID
        path
        preferredID
        shardID
        email
        sub
        receivedSurvey
        profileChoices {
          avatar
          birthMonth
          birthYear
          catchphrase
          goal
          careerStage
          careerConfidence
          topThemes
        }
        dob
        applicationOnlineID
        worksite
        worksiteVisits {
          id
          visitDate
        }
        careerPlan {
          lastUpdatedAt
          planStatus
          pathwayId
          careerPlanId
          approvedAt
        }
        coursePlan {
          lastUpdatedAt
          planStatus
          pathwayId
          coursePlanId
          programId
          programName
          districtPathwayId
          districtPathwayName
          cteCourseSequence {
            id
            name
          }
          approvedAt
          createdAt
        }
        username
        xp
        contractTTL
        grades
        enrollmentId
        enrollmentPath
      }
      nextToken
    }
  }
`;

export const GET_CLIMBERS_BY_SCHOOL = `
  query getClimbersBySchool($input: GetClimbersBySchoolInput!) {
    getClimbersBySchool(input: $input) {
      climbers {
        id
        firstName
        lastName
        parentID
        path
        preferredID
        email
        username
        grades
        careerPlan {
          careerPlanId
          planStatus
          pathwayId
          lastUpdatedAt
          approvedAt
        }
        coursePlan {
          coursePlanId
          planStatus
          pathwayId
          lastUpdatedAt
          approvedAt
          createdAt
          programId
          programName
          districtPathwayId
          cteCourseSequence {
            id
            name
          }
        }
      }
      nextToken
    }
  }
`;

export const UPDATE_CLIMBER_XP = `
  mutation updateClimberXP($input: UpdateClimberInput!) {
    updateClimberXP(input: $input) {
      xp
    }
  }
`;

export const UPDATE_DISTRICT = `
  mutation updateDistrict($input: updateDistrictInput!) {
    updateDistrict(input: $input) {
      contractTTL
      districtName
      loginMethod
      id
      parentID
      path
      shardID
      syncID
      centralizedAssignments
      country
      state
      msa
      nomenclature
      worksiteRequirements
      accessToken
      shouldSync
      checkinStartMonth
      checkinStartDay
      checkinEndMonth
      checkinEndDay
      planAvailability {
        startMonth
        startDay
        endMonth
        endDay
      }
      resourceHubUrl
    }
  }
`;

export const UPDATE_CLIMBER_NAME = `
  mutation updateClimberName($input: UpdateClimberInput!) {
    updateClimberName(input: $input) {
      id
      path
      firstName
      lastName
    }
  }
`;

export const ADD_TO_SECTION = `
  mutation addToSection($input: AddToSectionInput!) {
    addToSection(input: $input) {
      id
      path
      firstName
      lastName
    }
  }
`;

export const UPDATE_CLIMBER_RECEIVED_SURVEY = `
  mutation updateClimberReceivedSurvey($input: UpdateClimberInput!) {
    updateClimberReceivedSurvey(input: $input) {
      id
      receivedSurvey
    }
  }
`;

export const REPAIR_USER_SUB = `
  mutation repairClimberSub($input: RepairClimberSubInput!) {
    repairClimberSub(input: $input) {
      id
      path
      sub
      lastRepairedDate
    }
  }
`;

export const INVOKE_LEARNOSITY_LAMBDA_QUERY = `
  query invokeLearnosityLambda($payload: InvokeLearnosityLambdaInput!) {
    invokeLearnosityLambda(payload: $payload)
  }
`;

export const INVOKE_PASSPHRASE_GENERATOR_LAMBDA_QUERY = `
  query invokePassphraseGeneratorLambda(
    $payload: PassphraseGeneratorLambdaInput!
  ) {
    invokePassphraseGeneratorLambda(payload: $payload)
  }
`;

export const INVOKE_PASSWORD_RESET_LAMBDA_QUERY = `
  query invokePasswordResetLambda($payload: PasswordResetLambdaInput!) {
    invokePasswordResetLambda(payload: $payload)
  }
`;

export const INVOKE_BATCH_UPDATE_USER_SUB_QUERY = `
  query invokeBatchUpdateUserSubLambda($payload: BatchUpdateUserSubInput!) {
    invokeBatchUpdateUserSubLambda(payload: $payload)
  }
`;

export const INVOKE_GROUP_ASSIGN_LAMBDA_QUERY = `
  query invokeGroupAssignLambda($payload: GroupAssignLambdaInput!) {
    invokeGroupAssignLambda(payload: $payload)
  }
`;

export const INVOKE_EDLINK_TOKEN_MAPPER_LAMBDA_QUERY = `
  query invokeEdlinkTokenMapperLambda($payload: EdlinkTokenMapperLambdaInput!) {
    invokeEdlinkTokenMapperLambda(payload: $payload)
  }
`;

export const GET_CAREER_CLIMBS_BY_ID_AND_PATH = `
  query getCareerClimbsByIdAndPath($input: UpdateCareerClimbDueByInput!) {
    getCareerClimbsByIdAndPath(input: $input) {
      assignedStart
      dueBy
      startDate
      completeDate
      id
      learnosityTag
      parentID
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const GET_CAREER_CLIMBS = `
  query getCareerClimbsByShardId($shardID: String, $userPath: String) {
    getCareerClimbsByShardId(shardID: $shardID, userPath: $userPath) {
      assignedStart
      dueBy
      startDate
      completeDate
      id
      learnosityTag
      parentID
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const GET_CAREER_CLIMBS_BY_PARENT_ID = `
  query getCareerClimbsByParentId($parentID: String!, $shardID: String!) {
    getCareerClimbsByParentId(parentID: $parentID, shardID: $shardID) {
      assignedStart
      completeDate
      dueBy
      id
      learnosityTag
      parentID
      startDate
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

// TODO - get rid of this in favor of the more generic GET_CAREER_CLIMBS_BY_PARENT_ID
export const GET_CAREER_CLIMBS_BY_SECTION_ID = `
  query getCareerClimbsBySectionId($sectionID: String!) {
    getCareerClimbsBySectionId(sectionID: $sectionID) {
      assignedStart
      completeDate
      dueBy
      id
      learnosityTag
      parentID
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const GET_ACTIVITY_COMPLETION_BY_PARENT_ID = `
  query getActivityCompletionByParentId($parentID: String!, $id: ID!, $productCode: String) {
    getActivityCompletionByParentId(parentID: $parentID, id: $id, productCode: $productCode) {
      id
      parentID
      path
      responses {
        promptId
        responseId
      }
      pathwayScores {
        pathwayId
        score
      }
      connectorScores {
        connectorId
        score
      }
      timestamp
    }
  }
`;

export const ASSIGN_CAREER_CLIMB = `
  mutation createOrUpdateCareerClimb($input: CareerClimbProgressInput) {
    createOrUpdateCareerClimb(input: $input) {
      assignedStart
      dueBy
      id
      learnosityTag
      parentID
      path
      shardID
      startDate
      completeDate
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const SET_SAVED_STATUS = `
  mutation setSavedStatus($hatId: ID!, $saved: Boolean!, $product: String) {
    setSavedStatus(hatId: $hatId, saved: $saved, product: $product)
  }
`;

export const SET_FAVORITE_STATUS = `
  mutation setFavoriteStatus($hatId: ID!, $favorite: Boolean!, $product: String) {
    setFavoriteStatus(hatId: $hatId, favorite: $favorite, product: $product)
  }
`;

export const SET_HEARD_OF_STATUS = `
  mutation setHeardOfHatStatus($hatId: ID!, $heardOf: Boolean!, $product: String) {
    setHeardOfHatStatus(hatId: $hatId, heardOf: $heardOf, product: $product)
  }
`;

export const SEND_MESSAGE = `
  mutation createOrUpdateMessage($input: MessageInput) {
    createOrUpdateMessage(input: $input) {
      id
    }
  }
`;

// WorkSites
export const CREATE_OR_UPDATE_WORKSITE = `
  mutation createOrUpdateWorkSite($input: WorkSiteInput) {
    createOrUpdateWorkSite(input: $input) {
      id
      parentID
      shardID
      path
      companyName
      address
      supervisor
      phoneNumber
      createdAt
      updatedAt
      createdBy
      lastModifiedBy
    }
  }
`;

export const GET_WORKSITES_FOR_DISTRICT = `
  query getWorkSitesForDistrict($parentID: String) {
    getWorkSitesForDistrict(parentID: $parentID) {
      id
      parentID
      shardID
      path
      companyName
      address
      supervisor
      phoneNumber
      createdAt
      updatedAt
      createdBy
      lastModifiedBy
    }
  }
`;

export const DELETE_CAREER_CLIMB = `
  mutation deleteCareerClimbs($input: DeleteItemInput!) {
    deleteCareerClimbs(input: $input) {
      success
    }
  }
`;

export const DELETE_ITEM = `
  mutation deleteItem($input: DeleteItemInput!) {
    deleteItem(input: $input) {
      success
    }
  }
`;

export const UNDO_DELETE = `
  mutation UndoDelete($input: UndoDeleteInput!) {
    undoDelete(input: $input)
  }
`;

export const DELETE_USER_ROW = `
  mutation deleteUserRow($id: ID!, $path: String!) {
    deleteUserRow(id: $id, path: $path) {
      success
    }
  }
`;

export const UPDATE_TEACHER = `
  mutation createOrUpdateTeacher($input: TeacherInput) {
    createOrUpdateTeacher(input: $input) {
      id
      sub
      parentID
      path
      shardID
      username
      firstName
      lastName
      contractTTL
      email
    }
  }
`;

export const CREATE_ENROLLMENT = `
  mutation createEnrollment($input: EnrollmentInput!) {
    createEnrollment(input: $input) {
      id
      parentID
      path
      sectionID
      schoolID
    }
  }
`;

export const DELETE_ENROLLMENT = `
  mutation deleteEnrollment($id: ID!, $path: String!) {
    deleteEnrollment(id: $id, path: $path) {
      success
    }
  }
`;

export const UPDATE_SCHOOL_STAFF = `
  mutation createOrUpdateSchoolStaff($input: SchoolStaffInput) {
    createOrUpdateSchoolStaff(input: $input) {
      id
      sub
      parentID
      path
      shardID
      username
      firstName
      lastName
      contractTTL
      email
    }
  }
`;

export const UPDATE_CLIMBER = `
  mutation createOrUpdateClimber($input: ClimberInput) {
    createOrUpdateClimber(input: $input) {
      id
      sub
      parentID
      path
      shardID
      username
      firstName
      lastName
      contractTTL
      xp
      receivedSurvey      
    }
  }
`;

export const UPDATE_CAREER_CLIMB_ASSIGNMENT_DETAILS = `
  mutation updateCareerClimbAssignmentDetails(
    $input: UpdateCareerClimbAssignmentInput
  ) {
    updateCareerClimbAssignmentDetails(input: $input)
  }
`;

export const GET_MESSAGES = `
  query getMessages($subscriptionID: String!) {
    getMessages(subscriptionID: $subscriptionID) {
      careerClimbID
      careerPlanId
      learnosityTag
      content
      id
      parentID
      image
      path
      subscriptionID
      type
      timestamp
      readBy
      sender {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const MARK_MESSAGE_AS_READ = `
  mutation markMessageAsRead(
    $messageID: ID!
    $userID: String!
    $path: String!
    $contractTTL: Int!
  ) {
    markMessageAsRead(messageID: $messageID, userID: $userID, path: $path, contractTTL: $contractTTL) {
      id
    }
  }
`;

export const INVOKE_MANUAL_ROSTERING = `
  query invokeManualRosteringLambda($payload: ManualRosteringLambdaInput!) {
    invokeManualRosteringLambda(payload: $payload)
  }
`;

export const INVOKE_EMAIL_CHECKER = `
  query invokeEmailCheckerLambda($payload: EmailCheckerLambdaInput!) {
    invokeEmailCheckerLambda(payload: $payload)
  }
`;

export const INVOKE_CREATE_POK_CREDENTIAL = `
  query invokeCreatePokCredentialLambda($payload: InvokeCreatePokCredentialLambdaInput!) {
    invokeCreatePokCredentialLambda(payload: $payload)
  }
`;

export const INVOKE_CREATE_RUSTICI_REGISTRATION = `
  query invokeCreateRusticiRegistrationLambda($payload: InvokeCreateRusticiRegistrationLambdaInput!) {
    invokeCreateRusticiRegistrationLambda(payload: $payload)
  }
`;

export const INVOKE_CREATE_RUSTICI_LAUNCH_LINK = `
  query invokeCreateRusticiLaunchLinkLambda($payload: InvokeCreateRusticiLaunchLinkLambdaInput!) {
    invokeCreateRusticiLaunchLinkLambda(payload: $payload)
  }
`;

export const UPDATE_CLIMBERS_PROFILE_CHOICES = `
  mutation updateClimbersProfileChoices(
    $profileChoices: ProfileChoicesInput!
    $productCode: String!
  ) {
    updateClimbersProfileChoices(
      profileChoices: $profileChoices
      productCode: $productCode
    ) {
      id
    }
  }
`;

export const GET_EMBEDDABLE_REPORT_SIGNATURE = `
  query getEmbeddableReportSignature($input: EmbeddableReportSignatureInput!) {
    getEmbeddableReportSignature(input: $input) {
      token
      Status
      Error
    }
  }`;

export const GET_REPORT_SIGNATURE = `
  query getReportSignature($input: ReportSignatureInput!) {
    getReportSignature(input: $input) {
      EmbedUrl
      Status
      RequestId
      AnonymousUserArn
    }
  }
`;

export const LOG_EVENT = `
  mutation logEvent($input: LogEventInput!) {
    logEvent(input: $input)
  }
`;

export const UPLOAD_LOGO_URL = `
  mutation createUploadLogoUrl($districtID: String!, $fileType: String!) {
    createUploadLogoUrl(districtID: $districtID, fileType: $fileType)
}`;

export const COMPLETE_ACTIVITY = `
  mutation completeActivity($input: ActivityCompletionInput!) {
    completeActivity(input: $input) {
      id
    }
  }
`;

// Sentiment Queries
export const GET_CONNECTOR_SENTIMENTS = `
  query getConnectorSentiments($product: String) {
    getConnectorSentiments(product: $product) {
      connectorId
      sentiment
      reason
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATHWAY_SENTIMENTS = `
  query getPathwaySentiments($product: String) {
    getPathwaySentiments(product: $product) {
      pathwayId
      sentiment
      reason
      createdAt
      updatedAt
    }
  }
`;

export const GET_PERKS_QUIRKS_SENTIMENTS = `
  query getPerksQuirksSentiments($product: String) {
    getPerksQuirksSentiments(product: $product) {
      perksQuirksId
      sentiment
      reason
      createdAt
      updatedAt
    }
  }
`;

// Sentiment Mutations
export const RECORD_CONNECTOR_SENTIMENT = `
  mutation recordConnectorSentiment($input: ConnectorSentimentInput!) {
    recordConnectorSentiment(input: $input) {
      success
      message
    }
  }
`;

export const RECORD_PATHWAY_SENTIMENT = `
  mutation recordPathwaySentiment($input: PathwaySentimentInput!) {
    recordPathwaySentiment(input: $input) {
      success
      message
    }
  }
`;

export const RECORD_PERKS_QUIRKS_SENTIMENT = `
  mutation recordPerksQuirksSentiment($input: PerksQuirksSentimentInput!) {
    recordPerksQuirksSentiment(input: $input) {
      success
      message
    }
  }
`;

// Preference Queries
export const GET_CONNECTOR_PREFERENCES = `
  query getConnectorPreferences {
    getConnectorPreferences {
      connectorId
      score
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATHWAY_PREFERENCES = `
  query getPathwayPreferences($product: String) {
    getPathwayPreferences(product: $product) {
      pathwayId
      score
      createdAt
      updatedAt
    }
  }
`;

export const GET_BUILDING_BLOCK_ACTIVITIES_BY_PARENT_ID = `
  query GetBuildingBlockActivitiesByParentID($parentID: String!) {
    getBuildingBlockActivitiesByParentID(parentID: $parentID) {
      id
      categoryID
      activityID
      userActivityDescription
      userActivityDuration
      sentiments {
        connectorId
        sentiment
        reason
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_CLUSTER_PATHWAY_COMPLETIONS = `
  query ClusterPathwayCompletions($productCode: String) {
    getMyClusterCompletions(productCode: $productCode) {
      clusterId
      status
      statusUpdatedAt
      content {
        contentId
        details {
          blockType
          completionDate
          contentName
          contentType
          startDate
          status
        }
      }
    }
    getMyPathwayCompletions(productCode: $productCode) {
      content {
        contentId
        details {
          blockType
          completionDate
          contentType
          status
          startDate
          contentName
        }
      }
      pathwayId
    }
  }
`;

export const COMPLETE_CLUSTER_CONTENT = `
  mutation completeClusterContent(
    $input: MSCompleteClusterContentInput!
  ) {
    completeClusterContent(input: $input) {
      clusterId
    }
  }
`;

export const COMPLETE_PATHWAY_CONTENT = `
  mutation completePathwayContent(
    $input: MSCompletePathwayContentInput!
  ) {
    completePathwayContent(input: $input) {
      id
    }
  }
`;

export const SET_CLUSTER_STATUS = `
  mutation setClusterStatus(
    $input: MSSetClusterStatusInput!
  ) {
    setClusterStatus(input: $input) {
      id
      clusterId
      status
      statusUpdatedAt
    }
  }
`;

export const RESET_CURRENT_USER = `
  mutation resetCurrentUser(
    $confirmation: String!
    $options: ResetOptions
    $preserveEventTypes: [String!]
  ) {
    resetCurrentUser(
      confirmation: $confirmation
      options: $options
      preserveEventTypes: $preserveEventTypes
    ) {
      success
      message
    }
  }
`;

export const GET_NEXT_STEPS = `
  query getNextSteps($userPath: String!, $recentEvents: [RecentEventInput!], $productPlans: [String!], $productCode: String) {
    getNextSteps(userPath: $userPath, recentEvents: $recentEvents, productPlans: $productPlans, productCode: $productCode) {
      id
      title
      stepType
      description
      strand
      url
      trackingType
      order
      status
      instructions
      displayImage 
      progress {
        current
        target
      }
    }
  }
`;

export const GET_NEXT_STEPS_DEBUG = `
  query getNextStepsDebug($userPath: String!, $productPlans: [String!], $productCode: String) {
    getNextStepsDebug(userPath: $userPath, productPlans: $productPlans, productCode: $productCode) {
      availableStepsCount
      debug
      nextSteps {
        id
        description
        order
        status
        title
        url
        progress {
          current
          target
        }
      }
      userEventsCount
      existingIncompleteStepsCount
      userEvents {
        id
        eventType
        eventData
        timestamp
      }
      debugSteps {
        id
        title
        description
        url
        order
        strand
        status
        statusReason
        progress {
          current
          target
        }
        availabilityCheck
        completionCheck
      }
    }
  }
`;

export const UPDATE_NEXT_STEP_STATUS = `
  mutation updateNextStepStatus($input: UpdateNextStepStatusInput!) {
    updateNextStepStatus(input: $input) {
      success
      message
    }
  }
`;

export const GET_CLUSTER_STATUSES = `
  query getClusterStatuses($productCode: String) {
    getMyClusterStatuses(productCode: $productCode) {
      status
      clusterId
    }
  }
`;

export const CREATE_OR_UPDATE_WORKSITE_VISIT = `
  mutation createOrUpdateWorkSiteVisit($input: WorkSiteVisitInput!) {
    createOrUpdateWorkSiteVisit(input: $input) {
      visits {
        id
        path
        parentID
        shardID
        worksite
        climberIDs
        visitDate
        visitTime
        visitRatings {
          questionId
          question
          rating
        }
        visitComments
        supervisorName
        supervisorPhone
        createdAt
        updatedAt
        createdBy
      }
      isUpdate
    }
  }
`;

export const DELETE_WORKSITE_VISIT = `
  mutation deleteWorkSiteVisit($input: DeleteWorkSiteVisitInput!) {
    deleteWorkSiteVisit(input: $input)
  }
`;

export const CLEAR_CLIMBER_WORKSITE = `
  mutation clearClimberWorksite($input: ClearClimberWorksiteInput!) {
    clearClimberWorksite(input: $input) {
      success
      message
    }
  }
`;

export const GET_WORKSITE_VISITS_FOR_DISTRICT = `
  query getWorkSiteVisitsForDistrict($parentID: String!) {
    getWorkSiteVisitsForDistrict(parentID: $parentID) {
      id
      path
      parentID
      shardID
      worksite
      climberIDs
      visitDate
      visitTime
      visitRating
      visitComments
      supervisorName
      supervisorPhone
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export const GET_WORKSITE_VISIT_BY_ID = `
  query getWorkSiteVisitById($id: String!) {
    getWorkSiteVisitById(id: $id) {
      id
      path
      parentID
      shardID
      worksite
      climberIDs
      visitDate
      visitTime
      visitRatings {
        questionId
        question
        rating
      }
      visitComments
      supervisorName
      supervisorPhone
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export const GET_STUDENT_CAREER_PLAN = `
  query getStudentCareerPlan($climberId: ID!, $careerPlanId: ID!) {
    getStudentCareerPlan(climberId: $climberId, careerPlanId: $careerPlanId) {
      id
      path
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      likedItems
      dislikedItems
      hatId      
      buildingBlocks {
        buildingBlockId
        connectionText
      }
      nextStepIds
      planStatus
      interestText
      educationPathIds
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
      climber {
        id
        firstName
        lastName
        preferredID
        catchphrase
      }
      buildingBlocksActivities {
        id
        categoryID
        activityID
        userActivityDescription
        userActivityDuration
        sentiments {
          connectorId
          sentiment
          reason
        }
        createdAt
        updatedAt
      }
      perksQuirksSentiments {
        perksQuirksId
        sentiment
        reason
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_CAREER_PLAN_STATUS = `
  mutation updateCareerPlanStatus($input: MSUpdateCareerPlanStatusInput!) {
    updateCareerPlanStatus(input: $input) {
      id
      pathwayId
      hatId
      buildingBlocks {
        buildingBlockId
        connectionText
      }
      nextStepIds
      planStatus
      interestText
      educationPathIds
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

// Shout-Out Queries
export const GET_SHOUT_OUTS_FOR_STUDENT = `
  query getShoutOutsForStudent($climberId: ID!) {
    getShoutOutsForStudent(climberId: $climberId) {
      id
      parentID
      climberID
      connectorId
      message
      createdByName
      createdAt
    }
  }
`;

export const GET_MY_SHOUT_OUTS = `
  query getMyShoutOuts {
    getMyShoutOuts {
      id
      parentID
      climberID
      connectorId
      message
      createdByName
      createdAt
      acknowledged
    }
  }
`;

// Shout-Out Mutations
export const ACKNOWLEDGE_SHOUT_OUT = `
  mutation acknowledgeShoutOut($id: ID!) {
    acknowledgeShoutOut(id: $id) {
      id
      acknowledged
    }
  }
`;

export const CREATE_SHOUT_OUT = `
  mutation createShoutOut($input: MSCreateShoutOutInput!) {
    createShoutOut(input: $input) {
      id
      path
      parentID
      climberID
      connectorId
      message
      createdByUserId
      createdByType
      createdByName
      createdAt
    }
  }
`;

// Course Plan Queries
export const GET_MY_COURSE_PLANS = `
  query getMyCoursePlans($product: String) {
    getMyCoursePlans(product: $product) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      settingsVersionId
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const GET_COURSE_PLAN = `
  query getCoursePlan($id: ID!, $product: String) {
    getCoursePlan(id: $id, product: $product) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      settingsVersionId
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const GET_STUDENT_COURSE_PLAN = `
  query getStudentCoursePlan($climberId: ID!, $coursePlanId: ID!) {
    getStudentCoursePlan(climberId: $climberId, coursePlanId: $coursePlanId) {
      id
      path
      pathwayId
      schoolId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
      climber {
        id
        firstName
        lastName
        preferredID
        catchphrase
      }
    }
  }
`;

export const CREATE_COURSE_PLAN = `
  mutation createCoursePlan($input: MSCreateCoursePlanInput!) {
    createCoursePlan(input: $input) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      settingsVersionId
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const UPDATE_COURSE_PLAN = `
  mutation updateCoursePlan($input: MSUpdateCoursePlanInput!) {
    updateCoursePlan(input: $input) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      settingsVersionId
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

// --- Climb plans -----------------------------------------------------------
// One field selection, shared by all five documents. The course plan documents
// copy the same 60 lines four times and have already drifted apart once.
const CLIMB_PLAN_FIELDS = `
  id
  hatId
  planStatus
  connectProfile
  highSchoolPriorities
  skillsToBuild
  afterHighSchool
  signature
  feelings
  createdAt
  updatedAt
  approvedAt
  log {
    personName
    status
    comment
    timestamp
  }
`;

export const GET_MY_CLIMB_PLANS = `
  query getMyClimbPlans($product: String) {
    getMyClimbPlans(product: $product) { ${CLIMB_PLAN_FIELDS} }
  }
`;

export const GET_CLIMB_PLAN = `
  query getClimbPlan($id: ID!, $product: String) {
    getClimbPlan(id: $id, product: $product) { ${CLIMB_PLAN_FIELDS} }
  }
`;

export const CREATE_CLIMB_PLAN = `
  mutation createClimbPlan($input: MSCreateClimbPlanInput!) {
    createClimbPlan(input: $input) { ${CLIMB_PLAN_FIELDS} }
  }
`;

export const UPDATE_CLIMB_PLAN = `
  mutation updateClimbPlan($input: MSUpdateClimbPlanInput!) {
    updateClimbPlan(input: $input) { ${CLIMB_PLAN_FIELDS} }
  }
`;

export const DELETE_CLIMB_PLAN = `
  mutation deleteClimbPlan($id: ID!, $product: String) {
    deleteClimbPlan(id: $id, product: $product)
  }
`;

/**
 * The educator's read. `getClimbPlan` above is identity-scoped and can only
 * return the caller's own plan; this one is access-checked server-side against
 * the caller's sections, school or district.
 */
export const GET_STUDENT_CLIMB_PLAN = `
  query getStudentClimbPlan($climberId: ID!, $climbPlanId: ID!) {
    getStudentClimbPlan(climberId: $climberId, climbPlanId: $climbPlanId) {
      ${CLIMB_PLAN_FIELDS}
      climber {
        id
        firstName
        lastName
        preferredID
        grades
        schoolName
        districtName
        catchphrase
      }
    }
  }
`;

/**
 * Review. An educator sends `climberId` and may set any status; a climber
 * omits it and the server holds them to DRAFT/DRAFT_COMPLETE/SUBMITTED.
 */
export const UPDATE_CLIMB_PLAN_STATUS = `
  mutation updateClimbPlanStatus($input: MSUpdateClimbPlanStatusInput!) {
    updateClimbPlanStatus(input: $input) { ${CLIMB_PLAN_FIELDS} }
  }
`;

export const DELETE_COURSE_PLAN = `
  mutation deleteCoursePlan($id: ID!, $product: String) {
    deleteCoursePlan(id: $id, product: $product)
  }
`;

export const UPDATE_COURSE_PLAN_STATUS = `
  mutation updateCoursePlanStatus($input: MSUpdateCoursePlanStatusInput!) {
    updateCoursePlanStatus(input: $input) {
      id
      pathwayId
      planStatus
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

// Course Configuration Queries
export const GET_COURSE_CONFIG = `
  query getCourseConfig {
    getCourseConfig {
      id
      parentID
      path
      shardID
      courseData
      createdAt
      updatedAt
      createdBy
      lastModifiedBy
    }
  }
`;

export const UPDATE_COURSE_CONFIG = `
  mutation updateCourseConfig($input: MSUpdateCourseConfigInput!) {
    updateCourseConfig(input: $input) {
      id
      parentID
      path
      shardID
      courseData
      createdAt
      updatedAt
      createdBy
      lastModifiedBy
    }
  }
`;

export const GET_COURSE_PLAN_OPTIONS_FOR_SCHOOL = `
  query getCoursePlanOptionsForSchool($schoolId: ID!, $settingsVersionId: String) {
    getCoursePlanOptionsForSchool(schoolId: $schoolId, settingsVersionId: $settingsVersionId) {
      availablePrograms {
        programId
        programName
        matchType
        districtPathwayIds
      }
      districtPathways {
        id
        name
        pathwayType
        color
        cmsPathways {
          pathwayId
          matchType
        }
      }
      courseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      courses {
        id
        name
        credits
      }
      settingsVersionId
    }
  }
`;

export const GET_COURSE_PLAN_OPTIONS_FOR_SCHOOL_WITHOUT_VERSION = `
  query getCoursePlanOptionsForSchool($schoolId: ID!) {
    getCoursePlanOptionsForSchool(schoolId: $schoolId) {
      availablePrograms {
        programId
        programName
        matchType
        districtPathwayIds
      }
      districtPathways {
        id
        name
        pathwayType
        color
        cmsPathways {
          pathwayId
          matchType
        }
      }
      courseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      courses {
        id
        name
        credits
      }
      settingsVersionId
    }
  }
`;

export const ROSTER_SEARCH = `
  query rosterSearch($input: RosterSearchInput!) {
    rosterSearch(input: $input) {
      users {
        climberId
        firstName
        lastName
        email
        preferredId
        schools {
          schoolId
          schoolName
        }
        sections {
          sectionId
          sectionName
          schoolId
        }
      }
      pagination {
        total
        limit
        offset
        hasMore
      }
    }
  }
`;

export const USER_STATS = `
  query userStats($input: UserStatsInput!) {
    userStats(input: $input) {
      laddersCompleted
      climbsCompleted
      hatsHeardOf
      hatsLoved
      hatsLiked
      pathwaysLoved
      pathwaysLiked
      logins
      lastLogin
      clusterContentCompleted
    }
  }
`;

export const CAREER_PLAN_PATHWAYS_REPORT = `
  query careerPlanPathwaysReport($input: CareerPlanReportInput!) {
    careerPlanPathwaysReport(input: $input) {
      pathways {
        pathwayId
        uniqueClimberCount
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const CAREER_PLAN_EDUCATION_PATHS_REPORT = `
  query careerPlanEducationPathsReport($input: CareerPlanReportInput!) {
    careerPlanEducationPathsReport(input: $input) {
      educationPaths {
        educationPath
        uniqueClimberCount
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const TOTAL_CLIMBERS_REPORT = `
  query totalClimbersReport($reportInput: ReportInput!) {
    totalClimbersReport(input: $reportInput) {
      totalClimbers
    }
  }
`;

export const MY_TOTAL_CLIMBERS_REPORT = `
  query myTotalClimbersReport($reportInput: ReportInput!) {
    myTotalClimbersReport(input: $reportInput) {
      totalClimbers
    }
  }
`;

export const COURSE_PLAN_PATHWAYS_REPORT = `
  query coursePlanPathwaysReport($input: CoursePlanReportInput!) {
    coursePlanPathwaysReport(input: $input) {
      programs {
        programId
        programName
        pathways {
          districtPathwayId
          districtPathwayName
          uniqueClimberCount
        }
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const GET_PLAN_STATUSES = `
  query GetPlanStatuses($input: PlanStatusReportInput!) {
    planStatusReport(input: $input) {
      cacheInfo {
        generatedAt
        backgroundStarted
      }
      climbPlanStatus {
        schoolId
        schoolName
        totals {
          totalStudents
          draft
          draftComplete
          submitted
          revisionsRequested
          approved
        }
        teachers {
          teacherId
          teacherName
          counts {
            totalStudents
            draft
            draftComplete
            submitted
            revisionsRequested
            approved
          }
        }
      }
      coursePlanStatus {
        schoolId
        schoolName
        totals {
          totalStudents
          draft
          draftComplete
          submitted
          revisionsRequested
          approved
        }
        teachers {
          teacherId
          teacherName
          counts {
            totalStudents
            draft
            draftComplete
            submitted
            revisionsRequested
            approved
          }
        }
      }
    }
  }
`;

export const SITE_VISIT_TEACHER_REPORT = `
  query SiteVisitTeacherReport($input: SiteVisitTeacherReportInput!) {
    siteVisitTeacherReport(input: $input) {
      climbers {
        climber
        id
        firstName
        lastName
        schoolId
        grade
        sectionId
        teacherFirst
        teacherLast
        teacherId
        visit1
        visit2
        visit3
        visit4
        visit5
        visit6
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Returns a presigned S3 link, not the report — see useUrlDeliveredReport.
// Converted alongside the class view below so both halves of the report behave
// alike; a district's own site and group rows would reach the 6 MB inline limit
// eventually anyway.
export const CERTIFICATE_REPORT = `
  query CertificateReport($input: CertificateReportInput!) {
    certificateReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Returns a presigned S3 link, not the report — see useUrlDeliveredReport.
// One row per climber in the class, with no limit.
export const CERTIFICATE_CLASS_REPORT = `
  query CertificateClassReport($input: CertificateClassReportInput!) {
    certificateClassReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const EXPLORATION_REPORT = `
  query ExplorationReport($input: ExplorationReportInput!) {
    explorationReport(input: $input) {
      sites {
        siteId
        siteName
        totalClimbers
        none
        beginning
        moderate
        deep
        totalMomentsOfLearning
        totalClustersExplored
        totalPathwaysExplored
        totalHatsExplored
      }
      totals {
        totalClimbers
        none
        beginning
        moderate
        deep
        totalMomentsOfLearning
        totalClustersExplored
        totalPathwaysExplored
        totalHatsExplored
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Returns a presigned S3 link, not the report — see useUrlDeliveredReport.
// One row per climber in the school. The district-level
// EXPLORATION_REPORT above is aggregate and stays inline.
export const EXPLORATION_SCHOOL_REPORT = `
  query ExplorationSchoolReport($input: ExplorationSchoolReportInput!) {
    explorationSchoolReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Career Confidence Check-in Queries
export const GET_LAST_CAREER_CONFIDENCE_CHECKIN = `
  query getLastCareerConfidenceCheckin($product: String) {
    getLastCareerConfidenceCheckin(product: $product) {
      id
      careerStage
      careerConfidence
      changeExplanation
      createdAt
      isFromOnboarding
    }
  }
`;

export const SAVE_CAREER_CONFIDENCE_CHECKIN = `
  mutation saveCareerConfidenceCheckin($input: MSSaveCareerConfidenceCheckinInput!) {
    saveCareerConfidenceCheckin(input: $input) {
      id
      careerStage
      careerConfidence
      changeExplanation
      createdAt
      isFromOnboarding
    }
  }
`;

// Enrolled climber counts per session for the caller's district. Counts only —
// the session list comes from getSessionsByParentId, which is live; these
// follow the warehouse snapshot and can lag it.
export const DISTRICT_SESSION_CLIMBERS_REPORT = `
  query districtSessionClimbersReport($input: DistrictSessionClimbersInput!) {
    districtSessionClimbersReport(input: $input) {
      sessions {
        sessionId
        climbers
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// HATS STAFF ONLY. On an edit, send back the `path` the session was listed
// with — stored paths are not one shape and path is the sort key, so a
// constructed one writes a duplicate instead of updating.
export const CREATE_OR_UPDATE_SESSION = `
  mutation createOrUpdateSession($input: SessionInput!) {
    createOrUpdateSession(input: $input) {
      id
      path
      parentID
      name
      type
      state
      startDate
      endDate
    }
  }
`;

// Archives a session that sections still point at; hard-deletes one nothing
// references. `dryRun` reports which would happen without doing it.
export const DELETE_SESSION = `
  mutation deleteSession($input: DeleteSessionInput!) {
    deleteSession(input: $input) {
      archived
      deleted
      inUse
      sections
      sessionName
    }
  }
`;

export const GET_SESSIONS_BY_PARENT_ID = `
  query getSessionsByParentId($parentID: String!) {
    getSessionsByParentId(parentID: $parentID) {
      id
      parentID
      startDate
      endDate
      name
      type
      state
      path
      shardID
      contractTTL
    }
  }
`;

// Returns a presigned S3 link, not the report — see useUrlDeliveredReport.
// Several KB per climber: every climber carries a nested
// response per pathway, so a district roster is past the 6 MB inline limit
// long before the page's own filters would have narrowed it.
export const PATHWAY_INTERESTS_REPORT = `
  query PathwayInterestsReport($input: PathwayInterestsReportInput!) {
    pathwayInterestsReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const CLIMB_PLAN_INSIGHTS_REPORT = `
  query ClimbPlanInsightsReport($input: ClimbPlanInsightsReportInput!) {
    climbPlanInsightsReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const CLUSTER_PROGRESS_REPORT = `
  query ClusterProgressReport($input: ClusterProgressReportInput!) {
    clusterProgressReport(input: $input) {
      totalClimbers
      clusterStats {
        clusterId
        clusterName
        exploringCount
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Returns a presigned S3 link, not the report — see useUrlDeliveredReport.
// ~179 bytes per climber and no LIMIT on the query, so a
// school-wide scope of ~90k climbers is ~16 MB. Inlined, that came back null
// and the detail view rendered it as "no climbers have explored this
// cluster yet" — a transport failure that read as an empty result.
export const CLUSTER_DETAIL_REPORT = `
  query ClusterDetailReport($input: ClusterDetailReportInput!) {
    clusterDetailReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const DISTRICT_STATS_REPORT = `
  query districtStatsReport($input: DistrictStatsInput!) {
    districtStatsReport(input: $input) {
      schoolCount
      sectionCount
      coachCount
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const COACH_SHOUT_OUT_COUNT_REPORT = `
  query coachShoutOutCountReport($input: CoachShoutOutCountInput!) {
    coachShoutOutCountReport(input: $input) {
      count
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const COACH_SECTION_CLIMBERS_REPORT = `
  query coachSectionClimbersReport($input: CoachSectionClimbersReportInput!) {
    coachSectionClimbersReport(input: $input) {
      sections {
        sectionId
        sectionName
        totalClimbers
        activeClimbers
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Every district in one row. Hats staff only — the server restricts it to the
// HatsStaff group, so any other caller gets a 403 rather than a filtered list.
export const PLATFORM_DISTRICT_HEALTH_REPORT = `
  query platformDistrictHealthReport($input: PlatformDistrictHealthInput!) {
    platformDistrictHealthReport(input: $input) {
      districts {
        districtId
        districtName
        product
        rostered
        schools
        sections
        activated
        activatedPct
        active30d
        activePct
        engaged
        engagedPct
      }
      assignmentsInstrumented
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const RECENT_CLIMBER_ACTIVITY_REPORT = `
  query recentClimberActivityReport($input: RecentClimberActivityReportInput!) {
    recentClimberActivityReport(input: $input) {
      activities {
        climberId
        firstName
        lastName
        hatId
        hatName
        sentiment
        activityDate
      }
      hasMore
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Returns a presigned S3 link, not the report — see useUrlDeliveredReport.
// climbers, coaches and staff are all per-user rows for one
// site, and a single WF site can hold tens of thousands of climbers.
export const WF_SITE_DETAIL_REPORT = `
  query wfSiteDetailReport($input: WfSiteDetailReportInput!) {
    wfSiteDetailReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const MS_USAGE_ACTIVITY_REPORT = `
  query msUsageActivityReport($input: MsUsageActivityReportInput!) {
    msUsageActivityReport(input: $input) {
      sites {
        schoolId
        schoolName
        totalClimbers
        activatedClimbers
        activeClimbers
        medianActiveDays
        medianXp
      }
      totals {
        totalClimbers
        totalActivatedClimbers
        totalActiveClimbers
        medianActiveDays
        medianXp
      }
      sharedClimbers {
        schoolIds
        isActivated
        isActive
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Returns a presigned S3 link, not the report — see useUrlDeliveredReport.
// One row per climber in the school, alongside a row per
// class. Same unbounded shape as WF_SITE_DETAIL_REPORT above.
export const MS_SCHOOL_DETAIL_REPORT = `
  query msSchoolDetailReport($input: MsSchoolDetailReportInput!) {
    msSchoolDetailReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Returns a presigned S3 link, not the report. The body is tens of MB for a large
// district, well past Lambda's 6 MB response limit, so the browser downloads it
// from S3 itself — see useLadderTimeReport.
export const LADDER_TIME_REPORT = `
  query ladderTimeReport($input: LadderTimeReportInput!) {
    ladderTimeReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const WF_USAGE_ACTIVITY_REPORT = `
  query wfUsageActivityReport($input: WfUsageActivityReportInput!) {
    wfUsageActivityReport(input: $input) {
      sites {
        schoolId
        schoolName
        totalClimbers
        activeClimbers
        totalCoaches
        activeCoaches
        totalStaff
        activeStaff
      }
      coaches {
        userId
        firstName
        lastName
        email
        schoolId
        schoolName
        numGroups
        loginCount
        lastLogin
      }
      staff {
        userId
        firstName
        lastName
        email
        schoolId
        numSites
        loginCount
        lastLogin
      }
      admins {
        userId
        firstName
        lastName
        email
        loginCount
        lastLogin
      }
      totals {
        totalClimbers
        totalActiveClimbers
        totalActiveCoaches
        totalActiveStaff
        totalActiveAdmins
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const MS_MILESTONES_DISTRICT_REPORT = `
  query MsMilestonesDistrictReport($input: MsMilestonesDistrictReportInput!) {
    msMilestonesDistrictReport(input: $input) {
      keys
      total
      met
      schools {
        id
        name
        total
        met
      }
      sharedClimbers {
        groups
        met
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const MS_MILESTONES_SCHOOL_REPORT = `
  query MsMilestonesSchoolReport($input: MsMilestonesSchoolReportInput!) {
    msMilestonesSchoolReport(input: $input) {
      keys
      schoolName
      total
      met
      classes {
        id
        name
        total
        met
      }
      sharedClimbers {
        groups
        met
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// The only milestones query that returns names, and the only one that must carry
// a schoolId or sectionId — the server rejects a request with neither.
//
// URL-delivered: the body is downloaded from S3 rather than inlined here, so this
// asks only for the pointer. See useUrlDeliveredReport.
export const MS_MILESTONES_CLIMBERS_REPORT = `
  query MsMilestonesClimbersReport($input: MsMilestonesClimbersReportInput!) {
    msMilestonesClimbersReport(input: $input) {
      dataUrl
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// QA climber provisioning (/hldebug/provision-user). Backed by the internal
// tools source API, which is only merged in on dev and staging — on prod these
// fields don't exist and the page says so.
export const START_QA_PROVISION_JOB = `
  mutation startQaProvisionJob($input: QaProvisionJobInput!) {
    startQaProvisionJob(input: $input) {
      jobId
    }
  }
`;

export const GET_QA_PROVISION_JOB = `
  query getQaProvisionJob($jobId: ID!) {
    getQaProvisionJob(jobId: $jobId) {
      jobId
      status
      createdAt
      updatedAt
      mode
      productCode
      entryCount
      error
      progress {
        userIndex
        userCount
        usersDone
        phase
        line
        done
        total
        detail
      }
      events {
        ts
        level
        message
        userIndex
      }
      users {
        index
        status
        climberId
        username
        password
        applied
        skipped
        error
      }
    }
  }
`;
